import { render, staticRenderFns } from "./ownPackagesIsp.vue?vue&type=template&id=4fc1589b&"
import script from "./ownPackagesIsp.vue?vue&type=script&lang=js&"
export * from "./ownPackagesIsp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports